import React, { useState } from 'react';
import { animateScroll } from 'react-scroll';
import { useNavigate } from 'react-router-dom';
import Tooltip from 'rc-tooltip';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from '@buyside/components/presentation/Button/button';

import { useArchiveThreadMutation, useUnarchiveThreadMutation } from '@interfaces/graphql-typings';

const ArchiveThreadButton: React.FC<{ isArchived: boolean; threadNum: string }> = ({
  isArchived,
  threadNum
}) => {
  const navigate = useNavigate();

  const [tooltipVisible, setTooltipVisible] = useState(false);

  const [handleArchiveThread, { loading: archiveLoading }] = useArchiveThreadMutation({
    variables: { threadNum: threadNum.toString() },
    onCompleted: () => {
      navigate('/archive');
      animateScroll.scrollToTop();
    },
    onError: error => {
      throw error;
    }
  });

  const [handleUnarchiveThread, { loading: unarchiveLoading }] = useUnarchiveThreadMutation({
    variables: { threadNum: threadNum.toString() },
    onCompleted: () => {
      navigate('/');
      animateScroll.scrollToTop();
    },
    onError: error => {
      throw error;
    }
  });

  return (
    <Tooltip
      onVisibleChange={visible => setTooltipVisible(Boolean(visible))}
      overlay={
        <>
          <p>Are you sure you want to {isArchived ? 'unarchive' : 'archive'} this conversation?</p>
          <Button
            isLoading={archiveLoading || unarchiveLoading}
            onClick={isArchived ? handleUnarchiveThread : handleArchiveThread}
            size={BUTTON_SIZES.TINY}
            text="Confirm"
            type={BUTTON_TYPES.PRIMARY}
          />
          <Button
            disabled={archiveLoading || unarchiveLoading}
            onClick={() => setTooltipVisible(false)}
            size={BUTTON_SIZES.TINY}
            text="Cancel"
          />
        </>
      }
      placement="top"
      trigger={['click']}
      visible={tooltipVisible}
    >
      <Button
        text={`${isArchived ? 'Unarchive' : 'Archive'} This Conversation`}
        type={BUTTON_TYPES.LINK}
      />
    </Tooltip>
  );
};

export default ArchiveThreadButton;
